import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Link, useRouteMatch } from 'react-router-dom';
import { format, parseJSON } from 'date-fns';
export var FlyerTile = function (_a) {
    var _b = _a.flyerid, flyerid = _b === void 0 ? '' : _b, saledate = _a.saledate, size = _a.size;
    var url = useRouteMatch().url;
    return (_jsx("div", { className: "flex items-start rounded-lg shadow-lg hover:shadow-md transition-shadow  border border-gray-100", children: _jsxs(Link, { to: "".concat(url, "/").concat(flyerid), className: "p-8 inline-block w-full", children: [_jsx("p", { className: "font-bold text-xl mb-2 text-mmorange", children: format(parseJSON(saledate), 'MM/dd/y') }), _jsx("p", { className: "font-bold text-lg mb-1", children: size })] }) }));
};
FlyerTile.displayName = 'FlyerTile';
